import {FeedbackSuccessAction} from "../action/FeedbackDataAction.js"
const initialState = {
  interview: null,
};

const interviewFeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case FeedbackSuccessAction:
      return {
        ...state,
        interview: action.payload,
      };
    default:
      return state;
  }
};

export default interviewFeedbackReducer;
